import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["OperationalEvent"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getOperationalEventByMeasuringPoint: build.query<
        GetOperationalEventByMeasuringPointApiResponse,
        GetOperationalEventByMeasuringPointApiArg
      >({
        query: (queryArg) => ({ url: `/OperationalEvent/${queryArg}` }),
        providesTags: ["OperationalEvent"],
      }),
      getOperationalEvent: build.query<
        GetOperationalEventApiResponse,
        GetOperationalEventApiArg
      >({
        query: () => ({ url: `/OperationalEvent` }),
        providesTags: ["OperationalEvent"],
      }),
      getMeasurementCompleteStatus: build.query<
        GetMeasurementCompleteStatusApiResponse,
        GetMeasurementCompleteStatusApiArg
      >({
        query: () => ({ url: `/MeasurementCompleteStatus` }),
        providesTags: ["OperationalEvent"],
      }),
      getMeasuringPointAvailability: build.query<
        GetMeasuringPointAvailabilityApiResponse,
        GetMeasuringPointAvailabilityApiArg
      >({
        query: () => ({ url: `/MeasuringPointAvailability` }),
        providesTags: ["OperationalEvent"],
      }),
      getOperationalStatus: build.query<
        GetOperationalStatusApiResponse,
        GetOperationalStatusApiArg
      >({
        query: () => ({ url: `/OperationalStatus` }),
        providesTags: ["OperationalEvent"],
      }),
      getCommunicationStatus: build.query<
        GetCommunicationStatusApiResponse,
        GetCommunicationStatusApiArg
      >({
        query: () => ({ url: `/CommunicationStatus` }),
        providesTags: ["OperationalEvent"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as operationalEventApi };
export type GetOperationalEventByMeasuringPointApiResponse =
  /** status 200 OK */ OperationalEventDto[];
export type GetOperationalEventByMeasuringPointApiArg = string;
export type GetOperationalEventApiResponse =
  /** status 200 OK */ OperationalEventDto[];
export type GetOperationalEventApiArg = void;
export type GetMeasurementCompleteStatusApiResponse =
  /** status 200 OK */ MeasurementCompleteStatusDto[];
export type GetMeasurementCompleteStatusApiArg = void;
export type GetMeasuringPointAvailabilityApiResponse =
  /** status 200 OK */ MeasuringPointAvailabilityDto[];
export type GetMeasuringPointAvailabilityApiArg = void;
export type GetOperationalStatusApiResponse =
  /** status 200 OK */ OperationalStatusDto[];
export type GetOperationalStatusApiArg = void;
export type GetCommunicationStatusApiResponse =
  /** status 200 OK */ CommunicationStatusDto[];
export type GetCommunicationStatusApiArg = void;
export type OperationalEventDto = {
  id: number;
  description: string;
  start: number;
  measuringPoint: string;
  type: string;
  end?: number | null;
};
export type MeasurementCompleteStatusDto = {
  measuringPoint: string;
  substation: string;
  switchgear: string;
  description: string;
  status: number;
  start: number;
};
export type MeasuringPointAvailabilityDto = {
  measuringPoint?: string | null;
  substation?: string | null;
  switchgear?: string | null;
  deviceAvailable?: boolean;
  deviceAvailabilityLastUpdated?: string | null;
  routerAvailable?: boolean | null;
  routerAvailabilityLastUpdated?: string | null;
};
export type OperationalStatusDto = {
  measuringPoint: string;
  substation: string;
  switchgear: string;
  measurementCompleteStatus: number;
  communicationStatus: number;
};
export type CommunicationStatusDto = {
  measuringPoint: string;
  substation: string;
  switchgear: string;
  description: string;
  status: number;
  start: number;
};
export const {
  useGetOperationalEventByMeasuringPointQuery,
  useLazyGetOperationalEventByMeasuringPointQuery,
  useGetOperationalEventQuery,
  useLazyGetOperationalEventQuery,
  useGetMeasurementCompleteStatusQuery,
  useLazyGetMeasurementCompleteStatusQuery,
  useGetMeasuringPointAvailabilityQuery,
  useLazyGetMeasuringPointAvailabilityQuery,
  useGetOperationalStatusQuery,
  useLazyGetOperationalStatusQuery,
  useGetCommunicationStatusQuery,
  useLazyGetCommunicationStatusQuery,
} = injectedRtkApi;
